import {Component, Input, OnInit} from '@angular/core';
import {FormControl, ReactiveFormsModule} from "@angular/forms";
import {FormsService, SettingsService, SubtitlesService} from "../../../core";

@Component({
    selector: 'time-zones-list',
    standalone: true,
    imports: [ReactiveFormsModule],
    templateUrl: './time-zones-list.component.html',
    styleUrl: './time-zones-list.component.scss'
})
export class TimeZonesListComponent implements OnInit {
    @Input({required: true}) inputControl!: FormControl;
    @Input({ required: true }) id!: string;

    constructor(
        public forms: FormsService,
        private settings: SettingsService,
        public subtitles: SubtitlesService,
    ) {
    }

    ngOnInit(): void {
        this.forms.getTimeZones();
    }

    changeGmtId() {
        if (this.inputControl.value === null) {
            this.inputControl.setValue(this.settings.selectedModule.gmtId);
        }
    }
}
